/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_RefundedInputs */

const en_cargos_refunded = /** @type {(inputs: Cargos_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunded`)
};

const es_cargos_refunded = /** @type {(inputs: Cargos_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reembolsado`)
};

/**
* | output |
* | --- |
* | "Refunded" |
*
* @param {Cargos_RefundedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_refunded = /** @type {((inputs?: Cargos_RefundedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_RefundedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_refunded(inputs)
	return es_cargos_refunded(inputs)
});